import React from 'react';

const Step6IDVerification = ({ setCurrentStep, handleSubmitStep5, isSubmitting }) => {
  return (
    <div className="modal_content_body">
      <h3 className="ppt_form_title mb-5 text-center">Step 5: ID Verification</h3>
      <img src={process.env.PUBLIC_URL + '/assets/img/id_verify.png'} className='img-fluid' alt="ProperT - ID Verify" border="0" />
      <div className="d-flex justify-content-end gap-3 pt-4 kyc_btns">
        <button onClick={() => setCurrentStep(5)} className="ppt_btn_secondary alt text-dark">Back</button>
        <button
          onClick={handleSubmitStep5}
          className="ppt_btn_primary alt"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default Step6IDVerification;